import { Text } from "shared/components/Spor";
import styled from "styled-components";

export const DelayText = styled(Text)`
  color: ${({ theme }) => theme.colorTextDisabled};
`;
